/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_TitleInputs */

const en_pb_title = /** @type {(inputs: Pb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish your app`)
};

const id_pb_title = /** @type {(inputs: Pb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan aplikasimu`)
};

/**
* | output |
* | --- |
* | "Publish your app" |
*
* @param {Pb_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_title = /** @type {((inputs?: Pb_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_title(inputs)
	return en_pb_title(inputs)
});